export default __webpack_public_path__ + "static/scroll-04-d2eb2faac53107a7c030aa610f006326.jpg";